import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api';

interface Vars {
  groupId: string;
  userId: string;
}

/**
 * Self-leave a group. Server also supports owner-kicks via the same endpoint
 * but the UI spec restricts this hook to self-leave.
 *
 * Invalidates `['groups','my']` plus any standings / predictions caches
 * (they're scoped by active group — prefix-match invalidation works on
 * tuple keys).
 */
export function useLeaveGroup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ groupId, userId }: Vars) =>
      api.delete<{ ok: true }>(`/api/groups/${groupId}/members/${userId}`),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: ['groups', 'my'] });
      void qc.invalidateQueries({
        queryKey: ['groups', 'members', vars.groupId],
      });
      void qc.invalidateQueries({ queryKey: ['standings'] });
      void qc.invalidateQueries({ queryKey: ['predictions'] });
    },
  });
}
